import {
  USER_LOGIN_LOADING,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILED,
  VALIDATE_OTP_LOADING,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILED,
  VALIDATE_OTP_ARN_LOADING,
  VALIDATE_OTP_ARN_SUCCESS,
  VALIDATE_OTP_ARN_FAILED
  } from "../Constants/userConstants";
  
  export const userReducer = (state = { userData: [] }, action) => {
    switch (action.type) {
      case USER_LOGIN_LOADING:
        return { loading: true, userData: [] };
      case USER_LOGIN_SUCCESS:
        return { 
          loading: false, userData: action.payload
         };
      case USER_LOGIN_FAILED:
        return { loading: false, userData: [], error: action.payload };
      default:
        return state;
    }
  };


  export const verifyOtpReducer = (state = { otpData: [] }, action) => {
    switch (action.type) {
      case VALIDATE_OTP_LOADING:
        return { loading: true, otpData: [] };
      case VALIDATE_OTP_SUCCESS:
        return { 
          loading: false, otpData: action.payload
         };
      case VALIDATE_OTP_FAILED:
        return { loading: false, otpData: [], error: action.payload };
      default:
        return state;
    }
  };

  export const verifyOtpArnReducer = (state = { otpArnData: [] }, action) => {
    switch (action.type) {
      case VALIDATE_OTP_ARN_LOADING:
        return { loading: true, otpArnData: [] };
      case VALIDATE_OTP_ARN_SUCCESS:
        return { 
          loading: false, otpArnData: action.payload
         };
      case VALIDATE_OTP_ARN_FAILED:
        return { loading: false, otpArnData: [], error: action.payload };
      default:
        return state;
    }
  };


  
//   export const userVerificationCandidateReducer = (state = { userData: [] }, action) => {
//     switch (action.type) {
//       case USER_VERIFICATION_SUCCESS:
//         return { loading: false, userData: action.payload };
//       case USER_VERIFICATION_FAILED:
//         return { loading: false, error: action.payload };
//       default:
//         return state;
//     }
//   };
  
//   export const tokenVerificationReducer = (state = { tokenData: [] }, action) => {
//     switch (action.type) {
//       case TOKEN_VERIFICATION_SUCCESS:
//         return { loading: false, tokenData: action.payload };
//       case TOKEN_VERIFICATION_FAILED:
//         return { loading: false, error: action.payload };
//       default:
//         return state;
//     }
//   };
  